import { Result, Service } from "@models";
import requests from "./agent";

export const serviceService = {
  getAll: async (tenantId: number) => {
    const response = await requests.get<Result<Service[]>>(
      "/api/Service/GetAll",
      { params: { tenantId } }
    );
    return response.result;
  },
};
